"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-FormDesignerPalette',
    title: 'c-FormDesignerPalette__title',
    list: {
        container: 'c-FormDesignerPalette__list'
    },
    field: {
        container: 'c-FormDesignerPalette__field',
        title: 'c-FormDesignerPalette__title',
        isActive: 'c-FormDesignerPalette--is-active'
    }
};
exports.Style = (_a = {},
    _a[exports.CSS.list.container] = (_b = {
            display: 'flex',
            'flex-wrap': 'wrap'
        },
        _b["& .".concat(exports.CSS.field.container, ":hover")] = {
            cursor: 'pointer',
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
            'background-color': theme_1.DefaultTheme.font.color.divider
        },
        _b),
    _a[exports.CSS.container] = {
        display: 'flex',
        'align-items': 'center',
        'flex-direction': 'column',
        'margin-top': theme_1.DefaultTheme.space(2)
    },
    _a[exports.CSS.field.container] = {
        width: theme_1.DefaultTheme.space(25),
        padding: theme_1.DefaultTheme.space(3) + ' 0',
        'text-align': 'center',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'flex-direction': 'column'
    },
    _a[exports.CSS.field.title] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[exports.CSS.field.isActive] = {
        color: theme_1.DefaultTheme.font.color.link
    },
    _a);
//# sourceMappingURL=form.palette.style.js.map